import { useMemo, type ReactNode } from "react";
import { getAccessToken } from "@xplatform/platform";
import { createReviewApi, ReviewApi } from "@services/reviewApi";
import { ReviewApiContext } from "@services/reviewApiContext";

/**
 * Provides a single `ReviewApi` to the component tree. The default instance is
 * built from `VITE_API_BASE_URL` and the shared token store (`getAccessToken`
 * from `@xplatform/platform`, filled by the AuthBridge). Tests and the preview
 * server inject their own `ReviewApi` (a fake HTTP client / the fake API) via
 * the `api` prop, so no component imports the client directly.
 */
interface ReviewApiProviderProps {
  children: ReactNode;
  /** Overrides the default client (tests, preview fake API). */
  api?: ReviewApi;
}

export function ReviewApiProvider({ children, api }: ReviewApiProviderProps) {
  const client = useMemo(
    () => api ?? createReviewApi(() => getAccessToken()),
    [api],
  );
  return (
    <ReviewApiContext.Provider value={client}>
      {children}
    </ReviewApiContext.Provider>
  );
}
